/**
 * @file SalaryTypeList.jsx
 * @description Main view for listing all Salary Types.
 * It provides a page header with a title and a button to create new entries.
 */

import React from "react";
import SalaryTypeListTable from "./components/SalaryTypeListTable";
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const SalaryTypeList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    {/* Header Title */}
                    <HeadingOne>Salary Type List</HeadingOne>

                    {/* Integrated Add Button */}
                    <AddItemBtn url="add-salary-type" title="Create Salary Type" />
                </>
            }
        >
            <div className="col-12">
                {/* The main data table component */}
                <SalaryTypeListTable />
            </div>
        </PageBody>
    );
};

export default SalaryTypeList;

